import React from 'react';

const purple = '#6941E6';

const TermsAndConditions = () => (
  <div style={{ background: 'linear-gradient(135deg, #18171a 0%, #6941E6 100%)', color: '#fff', minHeight: '100vh', padding: '60px 0', fontFamily: 'inherit' }}>
    <div style={{ maxWidth: 800, margin: '40px auto', padding: '20px 24px', borderRadius: 18, background: '#232323', boxShadow: '0 4px 32px rgba(0,0,0,0.18)' }}>
      <h1 style={{ fontSize: '2.5rem', fontWeight: 700, marginBottom: 40, color: purple }}>Terms and Conditions</h1>
      <p style={{ fontSize: '1.1rem', marginBottom: 32 }}>
        Please read these Terms and Conditions carefully before using our website.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Acceptance of Terms</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        By accessing or using our website, you agree to be bound by these Terms and Conditions.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Use of the Site</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        You agree to use the site only for lawful purposes and in a way that does not infringe the rights of others.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Intellectual Properties</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        All content on this site is the propertie of VCNR Group or its licensors and is protected by copyright laws.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Limitation of Liability</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        We are not liable for any damages arising from your use of the site. Use the site at your own risk.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Changes to Terms</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 18 }}>
        We reserve the right to update these Terms and Conditions at any time. Continued use of the site constitutes acceptance of the new terms.
      </p>
      <h2 style={{ fontSize: '1.4rem', fontWeight: 600, margin: '40px 0 24px 0', color: purple }}>Contact Us</h2>
      <p style={{ fontSize: '1.08rem', marginBottom: 0 }}>
        If you have any questions about these Terms and Conditions, please contact us at <a href="mailto:info@vcnrworld.com" style={{ color: purple, textDecoration: 'underline' }}>info@vcnrworld.com</a>.
      </p>
    </div>
  </div>
);

export default TermsAndConditions; 